import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=5b5a372c&"
import script from "./publicLayout.js?vue&type=script&lang=js&"
export * from "./publicLayout.js?vue&type=script&lang=js&"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports